import React from 'react';
import DashboardCard from './DashboardCard';
import type { CostBreakdownItem } from './types';

interface DepartmentBarChartProps {
  items: CostBreakdownItem[];
  loading?: boolean;
}

const DepartmentBarChart: React.FC<DepartmentBarChartProps> = ({ items, loading }) => {
  const maxValue = Math.max(1, ...items.map((d) => d.value));

  if (loading) {
    return (
      <DashboardCard className="h-full" title="Labour Cost by Department">
        <div className="px-5 pb-5 flex-1 animate-pulse bg-gray-50 rounded-lg min-h-[220px]" />
      </DashboardCard>
    );
  }

  return (
    <DashboardCard className="h-full w-full flex flex-col" title="Labour Cost by Department">
      <div className="px-5 pb-5 flex-1 flex flex-col justify-center min-h-[220px] space-y-4">
        {items.length === 0 ? (
          <p className="text-sm text-gray-500 text-center py-4">No department data for this week.</p>
        ) : (
          items.map((dept) => {
            const widthPercent = (dept.value / maxValue) * 100;
            return (
              <div key={dept.name}>
                <div className="flex items-center justify-between text-xs mb-1.5">
                  <span className="text-gray-700 font-medium truncate pr-2">{dept.name}</span>
                  <span className="text-gray-500 flex-shrink-0">
                    €{dept.value.toLocaleString('en-IE')} · {dept.percent}%
                  </span>
                </div>
                <div className="h-3.5 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all"
                    style={{ width: `${widthPercent}%`, backgroundColor: dept.color }}
                  />
                </div>
              </div>
            );
          })
        )}
      </div>
    </DashboardCard>
  );
};

export default DepartmentBarChart;
